import script from "./TitlePart.vue?vue&type=script&setup=true&lang=js"
export * from "./TitlePart.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__